export default __webpack_public_path__ + "static/media/PerkLinkIcon.54f4c0b4.png";